<template>
	<BaseModal id="win-promocode">
		<template #default="{close}">
			<div class="modal modal--xxs modal--text-l">
				<div class="modal-close" @click="close"></div>
				<div v-if="status === 'WaitSendForm'" class="modal-form">
					<div class="modal-form__title">У вас глаз — алмаз (а если точнее: фианит). Вы отлично справились с заданием и нашли все предметы.</div>
					<div class="modal-form__subtitle">
						<p>Оставьте заявку на онлайн оценку Вашего имущества <br> Получите пониженную ставку 0.2% по промокоду в ближайшем ломбарде! </p>
					</div>
					<form class="form order-form" @submit.prevent="sendForm">
						<div class="form__inputs">
							<div class="form__inputs-input">
								<div class="default-input">
									<label class="default-input__label" for="dform-name">Имя</label>
									<div class="default-input__input">
										<input
											v-model="formData.name"
											type="text"
											inputmode="text"
											id="dform-name"
											placeholder="Иван"
											tabindex="0"
										>
									</div>
								</div>
							</div>

							<div class="form__inputs-input">
								<div class="default-input">
									<label class="default-input__label" for="dform-phone">Номер телефона</label>
									<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.phone.$errors.length}">
										<input v-model="formData.phone" type="tel" ref="inputPhone" placeholder="+7 (999) 549 34 95" id="dform-phone" autocomplete="off" inputmode="numeric" tabindex="0">
									</div>
									<div v-if="v$.formData.phone.$errors.length" class="default-input__error">
										<span v-for="(error, index) in v$.formData.phone.$errors" :key="index">{{error.$message}}</span>
									</div>
								</div>
							</div>

							<div class="form__inputs-input">
								<div class="default-input">
									<label class="default-input__label">Город</label>
									<div class="default-select">
										<Multiselect :label="'name'" searchable @click.stop @mousedown.stop :options="cities" v-model="formData.city" :track-by="'name'" :no-results-text="'Город не найден'" :placeholder="'Выберите город'" :can-clear="false" :can-deselect="false" :value-prop="'id'">
											<template #placeholder>
												<div class="multiselect-placeholder">
													<span>Выберите город</span>
												</div>
											</template>
										</Multiselect>
									</div>
									<!--								<div v-if="v$.formData.city.$errors.length" class="default-input__error">-->
									<!--								<span v-for="(error, index) in v$.formData.city.$errors" :key="index">{{-->
									<!--										error.$message-->
									<!--									}}</span>-->
									<!--								</div>-->
								</div>
							</div>

						</div>
						<div class="form__submit form__submit--bottom">
							<div class="form__submit-text">
								<div class="default-checkbox">
									<input hidden="" class="default-checkbox__input" id="checkbox-popup-win-promocode-advert-agreement" type="checkbox" name="advert-agreement" value="Y" required />
									<label class="default-checkbox__label" for="checkbox-popup-win-promocode-advert-agreement">
										<span>Я&nbsp;<a :href="documents['advertising-agreement']" target="_blank" >согласен на получение рекламы</a></span>
									</label>
								</div>
							</div>
							
							<div class="form__submit-btn">
								<button class="btn color shadow" :class="{'loading' : loading}" tabindex="0" type="submit">
									Отправить
								</button>
							</div>

							<div class="form__submit-text">
								<p>
									Нажимая кнопку «Отправить», вы даете информированное
									<a :href="documents['personal-data']" target="_blank">согласие на обработку персональных данных</a>
									в соответствии с <a :href="documents['policy']" target="_blank">Политикой обработки персональных данных потребителей</a>
								</p>
							</div>
						</div>
					</form>
				</div>
				<div v-if="status === 'WaitGetPromocode'" class="promocode-wait">
					<div class="promocode-wait__loading loading"></div>
					<div class="promocode-wait__title">Пожалуйста, подождите!</div>
					<div class="promocode-wait__description">Мы уже придумываем ваш промо код</div>
				</div>
				<div v-if="status === 'SuccessGetPromocode'" class="promocode-result">
					<div class="promocode-result__title">Спасибо!</div>
					<div class="promocode-result__description">Ваш промокод:</div>
					<div class="promocode-result__value">{{ promocode }}</div>
					<div class="promocode-result__description">Чтобы не потерять промокод, рекомендуем скачать наше мобильное приложение и авторизоваться в нем. Сделать это в 2 клика можно <a href="/get-app/">тут</a>.</div>
					<a href="/personal/" class="promocode-result__btn btn color shadow">Перейти в личный кабинет</a>
				</div>
				<div v-if="status === 'ErrorGetPromocode'" class="promocode-result">
					<div class="promocode-result__title">Ой,</div>
					<div class="promocode-result__description" v-html="errorText"></div>
					<a v-if="countAttempts === 3" href="/personal/" class="promocode-result__btn btn color shadow">Перейти в личный кабинет</a>
					<button v-else class="promocode-result__btn btn color shadow" @click="status = 'WaitSendForm'">Попробовать еще раз</button>
				</div>
			</div>
		</template>
	</BaseModal>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required, helpers, maxLength} from '@vuelidate/validators'
import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import { getCookie} from "@/utils/Cookie";
import { mapGetters, mapMutations, mapActions} from "vuex";
import BaseModal from "@/components/utils/BaseModal.vue";
import Inputmask from "inputmask";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";
import Multiselect from "@vueform/multiselect"

const {withMessage} = helpers
export default {
	name: "PopupWinPromocode",
	components: {
		BaseModal,
		Multiselect
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			loading: false,
			formData: {
				last_name: getCookie('userLastUsedSurname') || '',
				name: getCookie('userLastUsedSelfName') || '',
				email: getCookie('userLastUsedEmail') || '',
				city: '',
			},
			status: 'WaitSendForm',
			promocode: '',
			countAttempts: 0,
			errorText: '',
		}
	},
	validations() {
		return {
			formData: {
				phone: {
					required: withMessage('Необходимо указать телефон', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
			}
		}
	},

	mounted() {
		this.$watch('getModalOpened', () => {
			if (this.isModalOpened('win-promocode')) {
				setTimeout(() => {
					Inputmask('+7 (999) 999 99 99').mask(this.$refs.inputPhone);
				}, 1000)
			}
		}, {immediate: false})
	},

	computed: {
		cities() {
			return this.citiesList.map((city) => ({ name: city.name.charAt(0).toUpperCase() + city.name.slice(1), id: city.id }))
		},
		...mapGetters({
			documents: 'getDocuments',
			getModalOpened: 'modals/getModalOpened',
			isModalOpened: 'modals/isModalOpened',
			citiesList: 'location/getCitiesList',
		})
	},
	methods: {
		async sendForm() {

			const result = await this.v$.formData.$validate()
			if (!result) {
				return
			}
			this.status = 'WaitGetPromocode'
			this.countAttempts += 1


			// костыль потому что бэк не успел сделать все в одной форме
			if (this.countAttempts === 1) {
				const token = await executeRecaptcha()
				let body = objectToFormData({
					name: this.formData.name,
					phone: this.formData.phone,
					cityId: this.formData.city,
					token
				})
				await Fetch('forms/game-promocode/', {
					method: 'POST',
					body
				})
			}

			let body = objectToFormData({
				phone: this.formData.phone,
			})
			let response = await Fetch('personal/get-game-promocodes/', {
				method: 'POST',
				body
			})

			if (!response.success) {
				this.status = 'ErrorGetPromocode'
				this.errorText = response.message
				return
			}
			if (!response.data.length) {
				if (this.countAttempts < 3) {
					setTimeout(() => {
						this.sendForm()
					}, 10000);
				} else {
					this.status = 'ErrorGetPromocode'
					this.errorText = 'На формирование вашего промокода нам нужно немного больше времени. <br>Вы можете забрать его в ближайшее время в вашем личном кабинете.'
				}

			} else {
				this.status = 'SuccessGetPromocode'
				const result = response.data.find(item => item.sourceId === 'game')
				this.promocode = result.number
			}
		},
		clearForm() {
			this.formData = {
				name: getCookie('userLastUsedSelfName') || '',
				phone: getCookie('userLastUsedPhone') || '',
			}

			this.v$.$reset()
		},

		...mapActions({
			closeModal: 'modals/closeModal'
		}),
		...mapMutations({
			setSuccess: 'setPopupSuccessData'
		})
	}
}
</script>

<style scoped>

</style>
